import React from 'react';

import isFunction from 'lodash/isFunction';

import { useScreenGo } from '@gogame/screens';

import { TAB_ACTIONS_LOG } from 'scenes/SmartRules/SmartRuleDetails/SmartRuleDetails';
import {
  SmartRuleFormEdit,
  SmartRuleFormDuplicate,
} from 'scenes/SmartRules/SmartRuleForm';
import { STATUS_PENDING_FOR_APPROVAL } from 'scenes/SmartRules/constants';
import {
  useApprove,
  useReject,
  useActionApprove,
  useActionReject,
  useRemove,
  useStart,
  useStop,
} from 'scenes/SmartRules/data';
import { useDisabledActions, useInspection } from 'scenes/SmartRules/hooks';

import { ActionsComponent } from './Actions';

export const Actions = ({
  data = {},
  onOpenChildComponent,
  limit = 1,
  className,
  onClose,
  withViewLog = true,
}) => {
  const disabledActions = useDisabledActions({ data });
  const inspection = useInspection({ data });
  const [start] = useStart();
  const [stop] = useStop();
  const [approve] = useApprove();
  const [reject] = useReject();
  const [actionApprove] = useActionApprove();
  const [actionReject] = useActionReject();
  const [remove] = useRemove();
  const go = useScreenGo();

  const handleEdit = React.useCallback(() => {
    onOpenChildComponent(SmartRuleFormEdit, {
      id: data.id,
    });
  }, [data.id]);

  const handleStart = React.useCallback(() => {
    start({ id: data.id, name: data.name });
  }, [data.id, data.name]);

  const handleStop = React.useCallback(() => {
    stop({ id: data.id, name: data.name });
  }, [data.id, data.name]);

  const handleCopy = React.useCallback(() => {
    onOpenChildComponent(SmartRuleFormDuplicate, {
      id: data.id,
    });
  }, [data.id]);

  // TODO: remove actionApprove and actionReject after implement on server
  const handleApprove = React.useCallback(() => {
    if (data.status === STATUS_PENDING_FOR_APPROVAL) {
      actionApprove({ id: data.id, name: data.name });
    } else {
      approve({ id: data.id, name: data.name });
    }
  }, [data.id, data.name, data.status]);

  const handleReject = React.useCallback(() => {
    if (data.status === STATUS_PENDING_FOR_APPROVAL) {
      actionReject({ id: data.id, name: data.name });
    } else {
      reject({ id: data.id, name: data.name });
    }
  }, [data.id, data.name, data.status]);

  const handleDelete = React.useCallback(() => {
    remove({ id: data.id, name: data.name }).then(() => {
      if (isFunction(onClose)) {
        onClose();
      }
    });
  }, [data.id, data.name]);
  const handleViewLog = () => {
    go(data.id, {
      state: { activeTabId: TAB_ACTIONS_LOG },
    });
  };

  return (
    <ActionsComponent
      actions={data.ruleActions}
      limit={limit}
      className={className}
      disabled={disabledActions || inspection}
      onApprove={handleApprove}
      onReject={handleReject}
      onEdit={handleEdit}
      onStart={handleStart}
      onStop={handleStop}
      disabledByInspection={inspection}
      onCopy={handleCopy}
      onDelete={handleDelete}
      withViewLog={withViewLog}
      onViewLog={handleViewLog}
    />
  );
};

export default Actions;
